<app-page-heading [heading]="heading" [hasBackButton]="true"
                  [backPageName]="backPageName"
                  [tabName]="'products'">
</app-page-heading>

<div class="stepper-container">
  <mat-horizontal-stepper #stepper [linear]="true" (selectionChange)="onSelectionChanged()">

    <!----------------------------->
    <!---- STEP: General:---->
    <!----------------------------->

    <mat-step #step1 [completed]="productFormGroup.valid">
      <ng-template matStepLabel>General</ng-template>
      <form [formGroup]="productFormGroup">

        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
            <mat-form-field class="w-60">
              <mat-label>Product Name</mat-label>
              <input matInput type="text" formControlName="name" required (input)="onInputChangedUpdateProductName($event)">
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Product Name')">help_outline</mat-icon>
          </mat-grid-tile>

          <mat-grid-tile>
            <mat-form-field class="w-60">
              <mat-label>Claiming Days</mat-label>
              <input matInput formControlName="claimingDays" required
                     mask="separator.2" thousandSeparator=","
                     (blur)="onBlurTruncateDecimalPart('claimingDays')">
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Claiming Days')">help_outline</mat-icon>
          </mat-grid-tile>
        </mat-grid-list>

        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
            <mat-form-field class="w-60">
              <mat-label>Product Code</mat-label>
              <input matInput type="text" formControlName="productCode" required>
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Product Code')">help_outline</mat-icon>
          </mat-grid-tile>


          <mat-grid-tile>
            <mat-form-field class="w-60">
              <mat-label>Booking Days</mat-label>
              <input matInput formControlName="bookingDays" required
                     mask="separator.2" thousandSeparator=","
                     (blur)="onBlurTruncateDecimalPart('bookingDays')">
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Booking Days')">help_outline</mat-icon>
          </mat-grid-tile>

        </mat-grid-list>

        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
            <mat-form-field class="w-60">
              <mat-label>Approval Number</mat-label>
              <input matInput type="text" formControlName="approvalNumber" required>
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Approval Number')">help_outline</mat-icon>
          </mat-grid-tile>


          <mat-grid-tile>
            <mat-form-field class="w-60">
              <mat-label>Start Date</mat-label>
              <input formControlName="startDate"
                     [matDatepicker]="startDateDatePicker" matInput required
                     [max]="productFormGroup.controls.endDate.value">
              <mat-datepicker-toggle [for]="startDateDatePicker" matIconSuffix>
              </mat-datepicker-toggle>
              <mat-datepicker #startDateDatePicker></mat-datepicker>
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Start Date')">help_outline</mat-icon>
          </mat-grid-tile>
        </mat-grid-list>

        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
            <mat-form-field class="w-60">
              <mat-label>Payer Name</mat-label>
              <input matInput type="text" required
                     formControlName="payer"
                     (input)="payerTextChanged$.next($any($event.target).value)"
                     (blur)="onBlurPayerSelected()"
                     [matAutocomplete]="payerAuto">
              <mat-autocomplete #payerAuto="matAutocomplete">
                <mat-option (onSelectionChange)="onPayerSelected($event.source.value)"
                            *ngFor="let payer of filteredPayers" [value]="payer.name"
                            class="custom-mat-option">
                  {{payer.name}}
                </mat-option>
              </mat-autocomplete>
              <button *ngIf="productFormGroup.controls['payer'].value"
                      aria-label="Clear" mat-button mat-icon-button matSuffix
                      (click)="clearPayer()">
                <mat-icon style="color: grey;">clear</mat-icon>
              </button>
            </mat-form-field>

            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Payer name')">help_outline</mat-icon>
          </mat-grid-tile>

          <mat-grid-tile>
            <mat-form-field class="w-60">
              <mat-label>End Date</mat-label>
              <input formControlName="endDate"
                     [matDatepicker]="endDateDatePicker" matInput required
                     [min]="productFormGroup.controls.startDate.value">
              <mat-datepicker-toggle [for]="endDateDatePicker" matIconSuffix>
              </mat-datepicker-toggle>
              <mat-datepicker #endDateDatePicker></mat-datepicker>
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('End Date')">help_outline</mat-icon>
          </mat-grid-tile>
        </mat-grid-list>

        <mat-grid-list cols="2" rowHeight="75px">

          <mat-grid-tile>
            <mat-form-field class="w-60">
              <mat-label>Processing Class</mat-label>
              <mat-select formControlName="processingClass" required>
                <mat-option *ngFor="let option of processingClassLookUpValues" [value]="option.value">
                  {{option.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Processing Class')">help_outline</mat-icon>
          </mat-grid-tile>

          <mat-grid-tile>
            <mat-form-field class="w-60">
              <mat-label>Provider Network</mat-label>
              <input matInput type="text" required
                     formControlName="providerNetwork"
                     (input)="providerNetworkTextChanged$.next($any($event.target).value)"
                     (blur)="onBlurProviderNetworkSelected()"
                     [matAutocomplete]="providerNetworkAuto">
              <mat-autocomplete #providerNetworkAuto="matAutocomplete">
                <mat-option (onSelectionChange)="onProviderNetworkSelected($event.source.value)"
                            *ngFor="let providerNetwork of filteredProviderNetworks"
                            [value]="providerNetwork.name" class="custom-mat-option">
                  {{providerNetwork.name}}
                </mat-option>
              </mat-autocomplete>
              <button *ngIf="productFormGroup.controls['providerNetwork'].value"
                      aria-label="Clear" mat-button mat-icon-button matSuffix
                      (click)="clearProviderNetwork()">
                <mat-icon style="color: grey;">clear</mat-icon>
              </button>
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Provider Network')">help_outline</mat-icon>
          </mat-grid-tile>

        </mat-grid-list>

        <mat-grid-list cols="2" rowHeight="75px">

          <mat-grid-tile>
            <mat-form-field class="w-60">
              <mat-label>Regulator Name</mat-label>
              <mat-select formControlName="regulator" required>
                <mat-option *ngFor="let option of regulatorLookUpValues" [value]="option.value">
                  {{option.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Regulator name')">help_outline</mat-icon>
          </mat-grid-tile>


          <mat-grid-tile>
            <mat-form-field class="w-60">
              <mat-label>Currency</mat-label>
              <mat-select formControlName="currency" required>
                <mat-option *ngFor="let option of currencyLookUpValues" [value]="option.value">
                  {{option.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Currency')">help_outline</mat-icon>
          </mat-grid-tile>

        </mat-grid-list>

        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
            <mat-form-field class="w-60">
              <mat-label>Reporting Class</mat-label>
              <mat-select formControlName="reportingClass" required>
                <mat-option *ngFor="let option of reportingClassLookUpValues" [value]="option.value">
                  {{option.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Reporting Class')">help_outline</mat-icon>
          </mat-grid-tile>

          <mat-grid-tile>
            <mat-form-field class="w-60">
              <mat-label>Area of Cover</mat-label>
              <mat-select formControlName="areaOfCover" required>
                <mat-option *ngFor="let option of areaOfCoverLookUpValues" [value]="option.value">
                  {{option.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Area of Cover')">help_outline</mat-icon>
          </mat-grid-tile>
        </mat-grid-list>

        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
            <mat-form-field class="w-60">
              <mat-label>Email</mat-label>
              <input matInput type="text" formControlName="emailNotification">
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Email')">help_outline</mat-icon>
          </mat-grid-tile>
        </mat-grid-list>

        <div class="button-container">
          <button mat-raised-button color="warn" (click)="resetState()">Clear</button>
          <button mat-raised-button matStepperNext color="primary"
                  [disabled]="!productFormGroup.valid"
                  (click)="onSelectionChanged()">
            Next
          </button>
        </div>
      </form>
    </mat-step>

    <!------------------------------->
    <!-- STEP: Benefits and Limits:-->
    <!------------------------------->

    <mat-step #step2 [completed]="productFormGroup.valid && isPBLFormValid">
      <ng-template matStepLabel>Benefits and Limits</ng-template>
      <app-tree-benefits-and-limits [isEditMode]="isEditMode"
                                    [productDTO]="productDTO"
                                    (isValid)="isPBLFormValid = $event"
                                    (ProductBenefitLimitLinkDTOListChange)="onProductBenefitLimitLinkDTOListChanged($event)">
      </app-tree-benefits-and-limits>
    </mat-step>

  </mat-horizontal-stepper>
</div>
